export default __webpack_public_path__ + "static/media/thankYouIcon@svg.d86197be.svg";